import { useState, useEffect } from 'react';

interface WindowState {
  /** Width of the window */
  width?: number;
  /** Height of the window */
  height?: number;
}

/**
 * A React hook that adds a resize event-listener to the window and returns
 * the current window size
 */
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowState>({});

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

/**
 * Returns a formatted selector string for `id` or `className` attributes that
 * merges user generated classNames with component defaults.
 *
 * @param selectors - an array of classNames or ids supplied by component props.
 * Can be dynamically generated
 *
 */
export function cn(selectors: (string | undefined)[]): string | undefined {
  let s = selectors
    ? selectors
        .join(' ')
        .replace(/ +(?= )/g, '')
        .trim()
    : undefined;

  return s === '' ? undefined : s;
}
